export default {
    UPDATE_STARTED: (state, action) => {
        let actionId = action.payload.actionId;
        let actionIndex = action.payload.actionIndex;
        return state.setIn(["pendingUpdates", actionId], actionIndex);
    },

    UPDATE_ENDED: (state, action) => {
        let actionId = action.payload.actionId;
        let actionIndex = action.payload.actionIndex;
        if (state.getIn(["pendingUpdates", actionId]) === actionIndex) {
            return state.deleteIn(["pendingUpdates", actionId]);
        }
        return state;
    }
};
